import { useCallback } from "react"

import { appStore, useAuth } from "../store/AppStore"
import { isTicketValid } from "../utilities/common"

import useSdk, { ErrorLevel } from "./use-sdk"

export const useUserSubscriptionStatus = () => {
  const accessTokenState = appStore((state) => state.accessTokenState)
  const setCurrentUser = appStore((state) => state.setCurrentUser)
  const { onTokenExpired } = useAuth()
  const sdk = useSdk(ErrorLevel.NoError)
  const getCurrentUser = useCallback(async () => {
    if (!accessTokenState) return undefined
    return await sdk
      .currentUser()
      .then((data) => {
        setCurrentUser(data.currentUser)
        return data.currentUser
      })
      .catch(() => {
        onTokenExpired()
        return undefined
      })
  }, [setCurrentUser, accessTokenState, onTokenExpired])

  const refreshCurrentUserAndGetSubscriptionState = useCallback(async () => {
    return await getCurrentUser().then((data) =>
      isTicketValid(data?.ticket?.validUntil),
    )
  }, [getCurrentUser])

  return { refreshCurrentUserAndGetSubscriptionState, getCurrentUser }
}
